import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { breakpoints } = theme;

  return {
    rootContent: {
      display: "flex",
      backgroundColor: "#fff",
      width: "100%"
    },
    videoDetailsDesktopView: {
      [breakpoints.down(Breakpoints.SM_600)]: {
        display: "none"
      }
    }
  };
});
